import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";


/**
* class HSN.MultiItemBagModal
*
* Encapsulates the functionality of a modal dialog that contains information from a multi item add to bag.
**/
HSN.MultiItemBagModal = (function (parent) {
    __extends(MultiItemBagModal, parent);

    function MultiItemBagModal() {
        /**
        * new HSN.MultiItemBagModal()
        **/
        var modal = MultiItemBagModal.__super__.constructor.call(this);
        this.name = 'HSN.MultiItemBagModal';

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            closeBagModal(true, modal);
        });

        $(modal.Content).on('click', '.keep-shopping', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $(modal.Close).click();
        });

        $(modal.Content).on('click', '.checkout-button', function (e) {
            e.stopPropagation();
            e.preventDefault();

            var destinationUrl = $(this).data('destination-url');

            window.location.href = destinationUrl;
        });
    }

    function closeBagModal(dumpItems, modal) {
        modal.Hide();//not personalize, so hide modal
    }

    MultiItemBagModal.prototype._show = function (requests, callback) {
        var scope = this;

        this.Content.showHtml(
            '<div id="modal-processing"><h3>Processing</h3><div class="processing-symbol"><img alt="Processing" src="/assets/img/spinner-l-d8d9d9.gif" /></div></div>',
            0,
            function () {
                scope.Center();
                scope.Content.animate({ opacity: 1 });
            }
        );

        $.ajax("/bag/multi-item/post?" + new Date().getTime(),
        {
            context: this,
            contentType: 'application/json; charset=utf-8',
            dataType: 'html',
            type: 'POST',
            data: JSON.stringify({ 'input': requests }),
            success: function (data) {
                var scope = this;

                scope.Root.removeClass('loading');

                if (data.indexOf('window.location.href') > -1) {
                    this.Redirect = $('<div></div>');
                    this.Redirect.appendTo('body');

                    this.Redirect.showHtml(
                        data,
                        0
                    );
                }
                else {
                    this.Content.showHtml(
                    data,
                    0,
                    function () {
                        scope.Center();
                        scope.Content.animate({ opacity: 1 });
                    });
                }

                /*var bagCount = $('div .checkout-added-overlayDiv').attr('data-bag-count');
                if (bagCount > 0) HSN.Instance().AccountNavigation.SetBagItemCount(bagCount);*/

                if (callback) {
                    callback();
                }
            },
            error: function () {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
            }
        });
    };

    return MultiItemBagModal;

})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/MultiItemBagModal.js